<app-header />

<div class="min-h-screen bg-gray-50 flex items-start justify-center pt-8 pb-12 px-4 sm:px-6 lg:px-8">
  <div class="max-w-md w-full space-y-8">
    <div class="bg-white rounded-lg shadow-lg p-8">
      @if (isLoading) {
        <div class="flex flex-col items-center space-y-4">
          <svg class="animate-spin h-10 w-10 text-[#e8343f]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <p class="text-gray-700">Activando tu cuenta...</p>
        </div>
      } @else {
        @if (activationSuccess) {
          <div class="flex justify-center mb-6">
            <div class="rounded-full bg-green-100 p-3">
              <svg class="w-16 h-16 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>

          <h2 class="text-center text-2xl font-bold text-gray-900 mb-4">
            Cuenta activada
          </h2>

          <div class="text-center space-y-3 mb-6">
            <p class="text-gray-700">{{ activationMessage }}</p>
            @if (activationEmail) {
              <p class="text-sm text-gray-500">{{ activationEmail }}</p>
            }
          </div>

          <button
            type="button"
            (click)="goToLogin()"
            class="w-full py-3 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-[#e8343f] hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#e8343f] transition-colors"
          >
            Ir a Iniciar Sesion
          </button>
        } @else {
          <div class="flex justify-center mb-6">
            <div class="rounded-full bg-red-100 p-3">
              <svg class="w-16 h-16 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
          </div>

          <h2 class="text-center text-2xl font-bold text-gray-900 mb-4">
            No se pudo activar la cuenta
          </h2>

          <div class="text-center space-y-3 mb-6">
            <p class="text-gray-700">{{ errorMessage }}</p>
          </div>

          <button
            type="button"
            (click)="goToLogin()"
            class="w-full py-3 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-[#e8343f] hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#e8343f] transition-colors"
          >
            Ir a Iniciar Sesion
          </button>
        }
      }
    </div>
  </div>
</div>

<app-footer />
